import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import { css } from '@emotion/react';
import { hasPickBlockers, NEEDS_ALLOCATION_MESSAGE, MULTI_ORDER_PALLET_MESSAGE } from './pickBlockers';

const list = (entries) => entries.map((entry) => entry.label).join(', ');

const PickBlockedNotice = ({ blockers }) => {
    if (!hasPickBlockers(blockers)) return null;

    const { needsAllocation, multiOrderPallets, checkFailed } = blockers;

    return (
        <Alert
            severity={checkFailed ? 'error' : 'warning'}
            css={css`
                margin-bottom: 1rem;
            `}
        >
            <AlertTitle>Some items can't be picked or staged here</AlertTitle>
            {checkFailed ? (
                <div>
                    Could not check what is on this manifest's pallets, so picking and staging are turned off. Reload
                    the page to try again.
                </div>
            ) : null}
            {needsAllocation.length ? (
                <div>
                    <b>
                        {needsAllocation.length === 1 ? 'Order' : 'Orders'} {list(needsAllocation)}
                    </b>{' '}
                    — {NEEDS_ALLOCATION_MESSAGE}
                </div>
            ) : null}
            {multiOrderPallets.length ? (
                <div>
                    <b>
                        {multiOrderPallets.length === 1 ? 'Pallet' : 'Pallets'} {list(multiOrderPallets)}
                    </b>{' '}
                    — {MULTI_ORDER_PALLET_MESSAGE}
                </div>
            ) : null}
        </Alert>
    );
};

export default PickBlockedNotice;
